import { useEffect, useState } from 'react'

type Widths = Readonly<Record<string, number>>

function readWidths(key: string | undefined): Widths {
  if (!key) return {}
  try {
    const stored: unknown = JSON.parse(localStorage.getItem(key) ?? '{}')
    if (!stored || typeof stored !== 'object' || Array.isArray(stored)) return {}
    return Object.fromEntries(Object.entries(stored).filter(([, width]) =>
      typeof width === 'number' && Number.isFinite(width) && width > 0 && width <= 10000))
  } catch { return {} }
}

/** Only numeric display preferences are stored. Storage can be unavailable. */
export function useColumnWidths(storageKey: string | undefined) {
  const [state, setState] = useState(() => ({ key: storageKey, widths: readWidths(storageKey) }))
  if (state.key !== storageKey) setState({ key: storageKey, widths: readWidths(storageKey) })
  useEffect(() => {
    if (!state.key) return
    try { localStorage.setItem(state.key, JSON.stringify(state.widths)) } catch { /* Optional preference. */ }
  }, [state])
  return [state.widths, (widths: Widths) => setState({ key: storageKey, widths })] as const
}
